module.exports = __webpack_public_path__ + "media/images/favicon-7adda10ca49259aed65e42df10bfcd61.png";